export default {
	profile: {
		tabs: { perfil: 'Profile', info: 'Information', security: 'Security' },
		themeLight: 'Light theme',
		language: 'Language',
		logout: 'Log out',
		save: 'Save',
		emails: 'Emails',
		phones: 'Phones',
		addEmail: '+ Add email',
		addPhone: '+ Add phone',
		currentPassword: 'Current password',
		newPassword: 'New password',
		confirmPassword: 'Confirm new password',
		changePassword: 'Change password',
		cancel: 'Cancel',
		fillAllFields: 'Fill in all fields',
		passwordMismatch: 'New passwords do not match',
		photoUpdated: 'Photo updated',
		photoError: 'Error uploading photo',
		infoUpdated: 'Information updated',
		infoError: 'Error updating information',
		passwordUpdated: 'Password updated',
		passwordError: 'Error changing password',
		themeError: 'Error changing theme',
		languageUpdated: 'Language updated',
		languageError: 'Error changing language',
		name: 'Name',
	},
};
